// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EbEWl","footerLinks":"Footer_footerLinks__Itl2H"};